import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import NotFound from 'components/NotFound';
import TravelDocumentEditForm from 'components/TravelDocumentEditForm';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';

import { withData } from 'lib';
import { SettingsTravelDocumentEditPageQuery } from '__generated__/SettingsTravelDocumentEditPageQuery.graphql';

const query = graphql`
  query SettingsTravelDocumentEditPageQuery($id: ID!) {
    travelDocument(id: $id) {
      name

      ...EntitySidebar_entity
      ...TravelDocumentEditForm_document
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsTravelDocumentEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/travel-documents', name: 'Kelionės dokumentai' },
];

const SettingsTravelDocumentEditPage = ({ preloadedQuery }: Props) => {
  const { travelDocument } =
    usePreloadedQuery<SettingsTravelDocumentEditPageQuery>(
      query,
      preloadedQuery
    );

  if (!travelDocument) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={travelDocument} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: travelDocument.name,
        },
      ]}>
      <TravelDocumentEditForm document={travelDocument} />
    </PageWithSidebar>
  );
};

export default withData<SettingsTravelDocumentEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsTravelDocumentEditPage);
